import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SearchEntityType } from '@tribeplatform/gql-client/types';
import { Autocomplete } from '@tribeplatform/react-ui-kit/Autocomplete';
import { StackedList } from '@tribeplatform/react-ui-kit/StackedList';
import { useI18n } from '../i18n';
import { SearchRow } from './SearchRow';
import { cleanupSearchResult } from './utils';
export const SearchAutocompleteItems = ({ data }) => {
    var _a;
    const intl = useI18n();
    return (_jsx(_Fragment, { children: (data === null || data === void 0 ? void 0 : data.totalCount) > 0 &&
            ((_a = cleanupSearchResult(data)) === null || _a === void 0 ? void 0 : _a.hits.reduce((result, category, sectionIndex) => {
                result.sections.push(
                // eslint-disable-next-line react/no-array-index-key
                _jsxs(StackedList.Group, { children: [_jsx(StackedList.GroupTitle, { className: "first-letter:capitalize", children: category.entityType === SearchEntityType.External
                                ? intl.$t({
                                    id: 'Generics.KnowledgeBase',
                                    defaultMessage: 'Knowledge base',
                                })
                                : category.entityType }, void 0), category.hits.map((hit, personIndex) => {
                            const index = result.itemIndex;
                            result.itemIndex += 1;
                            return (_jsx(Autocomplete.Item
                            // eslint-disable-next-line react/no-array-index-key
                            , { value: hit, index: index, children: _jsx(SearchRow, { spacing: "sm", entityType: category.entityType, hit: hit }, void 0) }, personIndex));
                        })] }, sectionIndex));
                return result;
            }, { sections: [], itemIndex: 1 }).sections) }, void 0));
};
//# sourceMappingURL=SearchAutocompleteItems.js.map